import { Link } from '@remix-run/react';
import cx from 'classnames';

import Text from '~/components/Text';
import type { Publication } from '~/interfaces/publication';
import getNormalizedCategory from '~/utils/getNormalizedCategory';

interface Props {
  title: string;
  description: string;
  publication: Publication;
}

const CategoryHeader = ({ title, description, publication }: Props) => {
  return (
    <div className="border-b-2 border-wt-primary">
      <div className="flex flex-col justify-between sm:flex-row sm:items-end">
        <div className="space-y-2 py-2 text-4xl sm:py-4">
          <Text as="h1" type="title" theme="default" className="text-4xl text-wt-text-on-background">
            {title}
          </Text>
          <Text as="h2" type="title" theme="default" className="text-sm text-wt-text-on-background sm:text-lg">
            {description}
          </Text>
        </div>

        <div className="flex flex-wrap py-2">
          {publication.content_tags?.map((tag) => {
            const isSelected = tag.display === title;
            return (
              <Link
                key={tag.id}
                to={`/t/${getNormalizedCategory(tag.display)}`}
                className={cx(
                  'font-regular mb-2 ml-0 mr-2 cursor-pointer rounded rounded-wt border border-gray-300 px-2 py-1 text-xs sm:ml-2 sm:mr-0',
                  isSelected ? 'bg-wt-primary text-wt-text-on-primary' : 'text-wt-primary',
                )}
              >
                {tag.display}
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CategoryHeader;
